import { render, staticRenderFns } from "./GoalGuessing.vue?vue&type=template&id=b73e754a&scoped=true&"
import script from "./GoalGuessing.vue?vue&type=script&lang=js&"
export * from "./GoalGuessing.vue?vue&type=script&lang=js&"
import style0 from "./GoalGuessing.vue?vue&type=style&index=0&id=b73e754a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73e754a",
  null
  
)

export default component.exports